module.exports = __webpack_public_path__ + "img/card-Visa_Inc._logo.b1684820.svg";